<script>
import pointImg from '@/assets/point.png';
import { setCookie, getCookie } from '../../utils/utils';
import eventBus from '@/utils/eventBus';
import { isTourFinished } from '@/constants/onboardingTour';

const STORAGE_KEY = 'appGuideWidgetPos';
const EDGE_SNAP = 28; // 靠近边缘多少像素触发吸附
const DOCK_PEEK = 14; // 吸附后露出宽度

export default {
  data() {
    return {
      dialogVisible: false,
      kfImg: require('../../assets/codePic.png'),
      pointImg,
      isFirst: false,
      firstGuideVisible: false,
      isOpen: true,
      // 自由定位（left/top，相对视口）
      pos: { left: null, top: null },
      // 吸附边：null | 'left' | 'right' | 'top' | 'bottom'
      dock: null,
      dragging: false,
      dragMoved: false,
      dragOffset: { x: 0, y: 0 },
      dragStartClient: { x: 0, y: 0 },
    };
  },
  computed: {
    containerStyle() {
      if (this.dock) {
        return this.dockedStyle;
      }
      const left =
        this.pos.left != null
          ? this.pos.left
          : Math.max(0, window.innerWidth - 50);
      const top =
        this.pos.top != null
          ? this.pos.top
          : Math.max(0, window.innerHeight - 70);
      return {
        left: `${left}px`,
        top: `${top}px`,
        right: 'auto',
        bottom: 'auto',
        transform: 'none',
      };
    },
    dockedStyle() {
      const side = this.dock;
      const base = {
        right: 'auto',
        bottom: 'auto',
        left: 'auto',
        top: 'auto',
      };
      if (side === 'left') {
        return {
          ...base,
          left: '0',
          top: `${this.clampDockAlong('y')}px`,
          transform: 'none',
        };
      }
      if (side === 'right') {
        return {
          ...base,
          right: '0',
          top: `${this.clampDockAlong('y')}px`,
          transform: 'none',
        };
      }
      if (side === 'top') {
        return {
          ...base,
          top: '0',
          left: `${this.clampDockAlong('x')}px`,
          transform: 'none',
        };
      }
      return {
        ...base,
        bottom: '0',
        left: `${this.clampDockAlong('x')}px`,
        transform: 'none',
      };
    },
    menuPlacementClass() {
      if (this.dock === 'left') return 'menu-right';
      if (this.dock === 'right') return 'menu-left';
      if (this.dock === 'top') return 'menu-bottom';
      if (this.dock === 'bottom') return 'menu-top';
      return 'menu-top';
    },
    firstGuideStyle() {
      // 首次高亮条尽量贴近当前浮标上方
      if (this.pos.left == null || this.pos.top == null) {
        return {};
      }
      return {
        left: `${Math.max(0, this.pos.left - 72)}px`,
        top: `${Math.max(0, this.pos.top - 42)}px`,
        right: 'auto',
        bottom: 'auto',
      };
    },
  },
  mounted() {
    this.restorePos();
    window.addEventListener('resize', this.onResize);
    try {
      let data = getCookie('loginAccountInfo');
      data = JSON.parse(data);
      if (data && data.first) {
        if (isTourFinished()) {
          this.isFirst = true;
          this.isOpen = true;
          this.firstGuideVisible = true;
          this.dock = null;
        }
      }
    } catch (e) {
      // ignore
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    this.unbindDrag();
  },
  methods: {
    clampDockAlong(axis) {
      if (axis === 'y') {
        const t = this.pos.top != null ? this.pos.top : window.innerHeight / 2;
        return Math.min(Math.max(8, t), window.innerHeight - 48);
      }
      const l = this.pos.left != null ? this.pos.left : window.innerWidth / 2;
      return Math.min(Math.max(8, l), window.innerWidth - 48);
    },
    restorePos() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) {
          this.pos = {
            left: window.innerWidth - 50,
            top: window.innerHeight - 70,
          };
          return;
        }
        const saved = JSON.parse(raw);
        this.pos = {
          left: typeof saved.left === 'number' ? saved.left : window.innerWidth - 50,
          top: typeof saved.top === 'number' ? saved.top : window.innerHeight - 70,
        };
        this.dock = saved.dock || null;
        this.isOpen = this.dock ? false : saved.isOpen !== false;
        this.clampPos();
      } catch (e) {
        this.pos = {
          left: window.innerWidth - 50,
          top: window.innerHeight - 70,
        };
      }
    },
    persistPos() {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          left: this.pos.left,
          top: this.pos.top,
          dock: this.dock,
          isOpen: this.isOpen,
        })
      );
    },
    clampPos() {
      const size = this.dock ? DOCK_PEEK + 8 : 36;
      const maxL = Math.max(0, window.innerWidth - size);
      const maxT = Math.max(0, window.innerHeight - size);
      if (this.pos.left != null) {
        this.pos.left = Math.min(Math.max(0, this.pos.left), maxL);
      }
      if (this.pos.top != null) {
        this.pos.top = Math.min(Math.max(0, this.pos.top), maxT);
      }
    },
    onResize() {
      this.clampPos();
      this.persistPos();
    },
    commandClick(key) {
      switch (key) {
        case 'new':
          eventBus.$emit('restartSpotlightTour');
          break;
        case 'kf':
          this.dialogVisible = true;
          break;
      }
      this.isOpen = false;
      this.persistPos();
    },
    guideClick() {
      let data = getCookie('loginAccountInfo');
      data = JSON.parse(data);
      data.first = false;
      this.isFirst = false;
      setCookie('loginAccountInfo', JSON.stringify(data), 7 * 24 * 60 * 60 * 1000);
      const url = sessionStorage.getItem('newGuideUrl');
      window.open(url, '_blank');
      this.isOpen = false;
      this.persistPos();
    },
    notNeedClick() {
      this.firstGuideVisible = false;
      let data = getCookie('loginAccountInfo');
      data = JSON.parse(data);
      data.first = false;
      this.isFirst = false;
      setCookie('loginAccountInfo', JSON.stringify(data), 7 * 24 * 60 * 60 * 1000);
      this.isOpen = false;
      this.persistPos();
    },
    iconClick() {
      if (this.dragMoved) return;
      if (this.dock) {
        this.undockAndOpen();
        return;
      }
      this.isOpen = !this.isOpen;
      this.persistPos();
    },
    undockAndOpen() {
      const size = 30;
      if (this.dock === 'left') this.pos.left = 12;
      if (this.dock === 'right') this.pos.left = window.innerWidth - size - 12;
      if (this.dock === 'top') this.pos.top = 12;
      if (this.dock === 'bottom') this.pos.top = window.innerHeight - size - 12;
      this.dock = null;
      this.isOpen = true;
      this.clampPos();
      this.persistPos();
    },
    onDragStart(e) {
      if (e.button != null && e.button !== 0) return;
      const point = e.touches ? e.touches[0] : e;
      this.dragging = true;
      this.dragMoved = false;
      this.dragStartClient = { x: point.clientX, y: point.clientY };

      const el = this.$refs.guideWidget;
      const rect = el
        ? el.getBoundingClientRect()
        : { left: this.pos.left, top: this.pos.top };
      if (this.dock) {
        this.pos.left = rect.left;
        this.pos.top = rect.top;
        this.dock = null;
        this.isOpen = false;
      }
      this.dragOffset = {
        x: point.clientX - this.pos.left,
        y: point.clientY - this.pos.top,
      };
      this.bindDrag();
      e.preventDefault();
    },
    onDragMove(e) {
      if (!this.dragging) return;
      const point = e.touches ? e.touches[0] : e;
      const dx = point.clientX - this.dragStartClient.x;
      const dy = point.clientY - this.dragStartClient.y;
      if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
        this.dragMoved = true;
        this.isOpen = false;
      }
      this.pos.left = point.clientX - this.dragOffset.x;
      this.pos.top = point.clientY - this.dragOffset.y;
      this.clampPos();
      e.preventDefault();
    },
    onDragEnd() {
      if (!this.dragging) return;
      this.dragging = false;
      this.unbindDrag();
      if (this.dragMoved) {
        this.trySnapEdge();
        this.persistPos();
      }
      setTimeout(() => {
        this.dragMoved = false;
      }, 0);
    },
    trySnapEdge() {
      const size = 30;
      const l = this.pos.left;
      const t = this.pos.top;
      const r = window.innerWidth - (l + size);
      const b = window.innerHeight - (t + size);
      const dists = [
        { side: 'left', d: l },
        { side: 'right', d: r },
        { side: 'top', d: t },
        { side: 'bottom', d: b },
      ];
      dists.sort((a, c) => a.d - c.d);
      if (dists[0].d <= EDGE_SNAP) {
        this.dock = dists[0].side;
        this.isOpen = false;
      } else {
        this.dock = null;
      }
    },
    bindDrag() {
      document.addEventListener('mousemove', this.onDragMove);
      document.addEventListener('mouseup', this.onDragEnd);
      document.addEventListener('touchmove', this.onDragMove, { passive: false });
      document.addEventListener('touchend', this.onDragEnd);
    },
    unbindDrag() {
      document.removeEventListener('mousemove', this.onDragMove);
      document.removeEventListener('mouseup', this.onDragEnd);
      document.removeEventListener('touchmove', this.onDragMove);
      document.removeEventListener('touchend', this.onDragEnd);
    },
  },
};
</script>
<template>
  <div>
    <div
      ref="guideWidget"
      class="app-guide-container"
      data-tour="guide-widget"
      :class="[
        { 'is-dragging': dragging, 'is-docked': !!dock },
        dock ? `dock-${dock}` : '',
      ]"
      :style="containerStyle"
      @mousedown="onDragStart"
      @touchstart.prevent="onDragStart"
    >
      <div class="app-guide-content">
        <span
          class="app-guide-icon"
          :title="dock ? '点击展开，可拖动到边缘吸附隐藏' : '拖动可移动，靠近边缘可吸附隐藏'"
          @click.stop="iconClick"
        >
          <template v-if="dock">
            <i class="dock-chevron" :class="'chevron-' + dock" />
          </template>
          <template v-else>
            {{ isOpen ? 'X' : '?' }}
          </template>
        </span>
        <ul
          v-show="isOpen && !dock"
          class="app-guide-ul"
          :class="menuPlacementClass"
          @mousedown.stop
          @touchstart.stop
        >
          <li class="app-guide-li" @click="commandClick('new')">
            <i class="el-icon-question"></i>新手引导
          </li>
          <li class="app-guide-li" @click="commandClick('kf')">
            <i class="el-icon-chat-line-square"></i>在线客服
          </li>
        </ul>
      </div>
    </div>
    <el-dialog :title="$tt('运营客服')" width="400px" :visible.sync="dialogVisible">
      <div style="text-align:center;"><img class="image" :src="kfImg" :height="300" /></div>
    </el-dialog>
    <div v-if="isFirst">
      <div class="guide-first-mask"></div>
      <div class="guide-first" :style="firstGuideStyle" @click="guideClick">
        <i class="el-icon-question"></i>
        <span>新手引导</span>
        <div class="guide-point-continer">
          <img width="30px" :src="pointImg" />
        </div>
      </div>
    </div>
    <el-dialog
      :title="$tt('新手引导')"
      :visible.sync="firstGuideVisible"
      width="300px"
      class="first-guide-dialog"
      :modal="false"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
    >
      <p style="text-align:center;">
        系统检测到您是首次登录！<br/>
        请点击指定位置进行基础学习<br/>
        再来使用吧！
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="firstGuideVisible = false">{{ $tt("知道了") }}</el-button>
        <el-button type="danger" @click="notNeedClick">{{ $tt("无需学习") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<style lang="scss" scoped>
.app-guide-container {
  position: fixed;
  font-size: 20px;
  z-index: 5;
  user-select: none;
  touch-action: none;
  &.is-dragging {
    z-index: 10002;
    opacity: 0.92;
  }
  &.is-docked {
    z-index: 5;
    .app-guide-icon {
      border-radius: 4px;
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.18);
    }
  }
  &.dock-left .app-guide-icon {
    width: 14px;
    height: 40px;
    border-radius: 0 8px 8px 0;
  }
  &.dock-right .app-guide-icon {
    width: 14px;
    height: 40px;
    border-radius: 8px 0 0 8px;
  }
  &.dock-top .app-guide-icon {
    width: 40px;
    height: 14px;
    border-radius: 0 0 8px 8px;
  }
  &.dock-bottom .app-guide-icon {
    width: 40px;
    height: 14px;
    border-radius: 8px 8px 0 0;
  }
}
.app-guide-content {
  font-size: 14px;
  color: #fff;
  position: relative;
  .app-guide-ul {
    position: absolute;
    width: 102px;
    padding: 6px 0;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    border-radius: 4px;
    background: #303133;
    &.menu-top {
      right: 0;
      bottom: 36px;
    }
    &.menu-bottom {
      right: 0;
      top: 36px;
    }
    &.menu-left {
      right: 36px;
      bottom: 0;
    }
    &.menu-right {
      left: 36px;
      bottom: 0;
    }
    .app-guide-li {
      list-style: none;
      color: #fff;
      line-height: 27px;
      padding: 0 15px;
      font-size: 13px;
      cursor: pointer;
      &:hover {
        background: #484848;
      }
      i {
        margin-right: 5px;
      }
    }
  }
}
.app-guide-icon {
  background-color: #303133;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 6px rgb(0 0 0 / 12%);
  cursor: grab;
  color: #fff;
  font-size: 14px;
  &:active {
    cursor: grabbing;
  }
}
.dock-chevron {
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
  &.chevron-left {
    border-width: 5px 0 5px 6px;
    border-color: transparent transparent transparent #fff;
  }
  &.chevron-right {
    border-width: 5px 6px 5px 0;
    border-color: transparent #fff transparent transparent;
  }
  &.chevron-top {
    border-width: 6px 5px 0 5px;
    border-color: #fff transparent transparent transparent;
  }
  &.chevron-bottom {
    border-width: 0 5px 6px 5px;
    border-color: transparent transparent #fff transparent;
  }
}
.guide-first-mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10000;
  background: #000;
  opacity: 0.5;
}
.guide-first {
  position: fixed;
  z-index: 10001;
  right: 20px;
  bottom: 109px;
  width: 102px;
  height: 27px;
  background: #484848;
  cursor: pointer;
  color: #fff;
  line-height: 27px;
  padding: 0 15px;
  font-size: 13px;
  i {
    margin-right: 5px;
  }
  .guide-point-continer {
    position: absolute;
    left: 40%;
    top: 21px;
    img {
      transition: all 1s linear;
      animation-name: pointScaleAnim;
      animation-duration: 1.2s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
      animation-fill-mode: forwards;
    }
  }
}
.first-guide-dialog {
  z-index: 10001 !important;
}
</style>
<style lang="scss">
@keyframes pointScaleAnim {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.85);
  }
  100% {
    transform: scale(1);
  }
}
.app-guide-container {
  .el-dropdown {
    color: #fff;
  }
}
.app-guide-drop {
  .el-dropdown-menu__item {
    color: #fff;
  }
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background: #484848;
    color: #fff;
  }
  .popper__arrow {
    border-top-color: #303133 !important;
    &::after {
      border-top-color: #303133 !important;
    }
  }
}
</style>
